import { ParagraphElement } from './BufferEditor/types.plate';

export const createParagraphElement = (text: string): ParagraphElement => {
  return {
    type: 'p',
    children: [
      {
        text,
      },
    ],
  };
};

export const createParagraphsFromText = (
  text: string
): Array<ParagraphElement> => {
  return text.split('\n').map((line) => createParagraphElement(line));
};
